import { Injectable } from '@angular/core';
import { ApiServices } from '../shared/services/api.services';
import { ApiConstants } from '../shared/constants/api.constants';

@Injectable()
export class oktaLoginService {
    private header = { 'Content-Type': 'application/json' };
    constructor(private apiService: ApiServices, private apiConstants: ApiConstants) {
    }

    authenticateOkta(params: Object) {
        return this.apiService.serviceCall(
            this.apiConstants.authUrl.authenticateOkta.url,
            this.apiConstants.authUrl.authenticateOkta.method,
            params,
            null,
            this.header
        );
    }

    getConfig(params: Object) {
        return this.apiService.serviceCall(
            this.apiConstants.authUrl.getConfig.url,
            this.apiConstants.authUrl.getConfig.method,
            params,
            null,
            this.header
        );
    }

    getWebFingerConfig(resource, baseUrl) {
        const encodedResource = encodeURIComponent(`okta:acct:${resource}`);
        const webFingerUrl = `${baseUrl}/.well-known/webfinger?resource=${encodedResource}`;
        return this.apiService.serviceCall(
          webFingerUrl,
          'GET',
          null,
          null,
          this.header,
          true
        );
    }

    getRequestContext(und) {
        return this.apiService.serviceCall(
          this.apiConstants.authUrl.oktaRequestContext.url + '?idpId=' + und,
          this.apiConstants.authUrl.oktaRequestContext.method,
          null,
          null,
          this.header
        );
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/okta-login/okta-login.service.ts